import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { PaycheckFrequency } from './paycheck-frequency.interface';
import { PaycheckFrequencyService } from './paycheck-frequency.service';

const service = new PaycheckFrequencyService();

export interface PaycheckFrequencyState {
   paycheckFrequencies: Array<PaycheckFrequency>;
}

const PaycheckFrequencyStore: Module<PaycheckFrequencyState, StoreState> = {
   namespaced: true,
   state: { paycheckFrequencies: [] },
   getters: {
      paycheckFrequencies(state: PaycheckFrequencyState) {
         return state.paycheckFrequencies;
      },
   },
   mutations: {
      SET_PAYCHECK_FREQUENCIES(state: PaycheckFrequencyState, paycheckFrequencies: Array<PaycheckFrequency>) {
         state.paycheckFrequencies = paycheckFrequencies;
      },
   },
   actions: {
      async getPaycheckFrequencies(context: any) {
         return await service.getPaycheckFrequencies().then((response) => {
            context.commit('SET_PAYCHECK_FREQUENCIES', response);
            return response;
         });
      },
   },
};

export default PaycheckFrequencyStore;
